import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

// MSAL Instance Factory
export function MSALInstanceFactory(): IPublicClientApplication {
    const msalConfig = environment.msal;
    return new PublicClientApplication({
        auth: {
            clientId: msalConfig.clientId,
            authority: msalConfig.authority,
            redirectUri: window.location.origin + msalConfig.redirectUri
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage
        },
        system: {
            loggerOptions: {
                loggerCallback(logLevel: LogLevel, message: string) {
                    console.log(message);
                },
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    });
}
